const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$domSliderPrev: $('.slider .js-slider-arrow-arr-prev'),
	$domSliderNext: $('.slider .js-slider-arrow-arr-next'),
	$domSliderIcons: $('.js-slider-icons__slider'),
	$domSliderIconsPrev: $('.slider-icons .js-slider-arrow-arr-prev'),
	$domSliderIconsNext: $('.slider-icons .js-slider-arrow-arr-next'),
	$domSliderLogo: $('.js-slider-logo__slider'),
	$domSliderLogoPrev: $('.slider-logo .js-slider-arrow-arr-prev'),
	$domSliderLogoNext: $('.slider-logo .js-slider-arrow-arr-next'),
	$domSliderCartProduct: $('.js-cart-bottom__recommended-bottom'),
	$domSliderCartProductPrev: $('.cart-bottom__recommended-upper .js-slider-arrow-arr-prev'),
	$domSliderCartProductNext: $('.cart-bottom__recommended-upper .js-slider-arrow-arr-next'),
	$domSingleProductSlider: $('.js-single-product__slider'),
	$domSingleProductSliderPopup: $('.js-single-product__slider-popup'),
	$domSingleProductSliderSmall: $('.js-single-product__slider-small'),
	$domSingleProductSliderSmallPrev: $('.js-single-product__slider-small-arr-prev'),
	$domSingleProductSliderSmallNext: $('.js-single-product__slider-small-arr-next'),
	$domRelatedProductsSlider: $('.js-single-product__related-sliders'),
	$domSliderSingleProduct: $('.js-single-product__bottom-slider'),
	$domSliderSingleProductPrev: $('.single-product__bottom-slider-upper .js-slider-arrow-arr-prev'),
	$domSliderSingleProductNext: $('.single-product__bottom-slider-upper .js-slider-arrow-arr-next'),
	$domSliderBanner: $('.js-banner-full__slider'),
	$domSliderBannerPrev: $('.banner-full .js-slider-arrow-arr-prev'),
	$domSliderBannerNext: $('.banner-full .js-slider-arrow-arr-next'),

	/** @description Initialize. */
	init: function() {
		this.initSlider();
		this.initSliderIcons();
		this.initSliderLogo();
		this.initSliderCartProductsRecommended();
		this.initSingleProductSlider();
		this.initSingleProductSliderSmall();
		this.initSliderSingleProduct();
		this.initSliderBanner();
		this.initSingleProductSliderPopup();
		if (jQuery(window).width() < 576) {
			$('.js-single-product__slider').addClass('js-popup-slider-popup-trigger');
		}

		$('.js-popup-slider-popup-trigger').on('click', function() {
			$('.js-slider-gallery-popup').addClass('active');
		});

		$('.popup-close').on('click', function() {
			$('.js-slider-gallery-popup').removeClass('active');
		});
	},

	/** @description Set and run gallery slider. */
	initSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: true,
			prevArrow: Sliders.$domSliderPrev,
			nextArrow: Sliders.$domSliderNext,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 501,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSlider, config);
	},

	initSliderIcons: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: true,
			arrows: true,
			prevArrow: Sliders.$domSliderIconsPrev,
			nextArrow: Sliders.$domSliderIconsNext,
			slidesToShow: 1,
			slidesToScroll: 1,
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderIcons, config);
	},

	initSliderLogo: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: true,
			arrows: true,
			prevArrow: Sliders.$domSliderLogoPrev,
			nextArrow: Sliders.$domSliderLogoNext,
			slidesToShow: 4,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				},
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderLogo, config);
	},

	initSliderCartProductsRecommended: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: true,
			prevArrow: Sliders.$domSliderCartProductPrev,
			nextArrow: Sliders.$domSliderCartProductNext,
			slidesToShow: 2,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 1
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 501,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderCartProduct, config);
	},

	initSingleProductSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: false,
			dots: false,
			touchThreshold: 200,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.js-single-product__slider-small',
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSingleProductSlider, config);
	},

	initSingleProductSliderPopup: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: false,
			dots: false,
			touchThreshold: 200,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.js-single-product__slider',
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSingleProductSliderPopup, config);
	},

	initSingleProductSliderSmall: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: true,
			prevArrow: Sliders.$domSingleProductSliderSmallPrev,
			nextArrow: Sliders.$domSingleProductSliderSmallNext,
			dots: false,
			touchThreshold: 200,
			focusOnSelect: true,
			vertical: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			asNavFor: '.js-single-product__slider',
			responsive: [
				{
					breakpoint: 575,
					settings: {
						vertical: false,
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSingleProductSliderSmall, config);
	},

	initSliderSingleProduct: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: false,
			arrows: true,
			prevArrow: Sliders.$domSliderSingleProductPrev,
			nextArrow: Sliders.$domSliderSingleProductNext,
			slidesToShow: 5,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 4
					}
				},
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderSingleProduct, config);
	},

	initSliderBanner: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			autoplay: true,
			autoplaySpeed: 2500,
			arrows: true,
			dots: true,
			prevArrow: Sliders.$domSliderBannerPrev,
			nextArrow: Sliders.$domSliderBannerNext,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			// fade: true
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSliderBanner, config);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
